import { Injectable } from '@angular/core';
import { gfDateFunction } from '../../../core/pipes/date/date.functions';
import * as _ from 'lodash';
import * as d3 from 'd3';

@Injectable()
export class ScmChartService {
  constructor() {}

  // Chart options can be explored and tested at:
  // http://krispo.github.io/angular-nvd3/#/multiBarChart
  commitChartOptions = {
    chart: {
      type: 'multiBarChart',
      groupSpacing: 0.2,
      height: 250,
      legend: {
        rightAlign: true,
      },
      noData: 'Sorry, not enough data!',
      reduceXTicks: false,
      reduceYTicks: true,
      rotateLabels: -45,
      showLegend: true,
      showControls: false,
      stacked: true,
      transitionDuration: 500,
      tooltip: {
        contentGenerator: (d) => {
          const header = gfDateFunction(d.data.x);
          const headerhtml = `<thead><tr><td colspan='3'><strong class='x-value'>${header}</strong></td></tr></thead>`;

          let bodyhtml = '<tbody>';
          d.series.forEach((seriesItem) => {
            bodyhtml += `<tr><td class='legend-color-guide'><div style='background-color: ${seriesItem.color};'></div></td><td class='key'>${seriesItem.key}</td><td class='value'>${seriesItem.value}</td></tr>`;
          });
          bodyhtml += '</tbody>';
          return `<table>${headerhtml}${bodyhtml}</table>`;
        },
      },
      useInteractiveGuideline: false,
      x: (d) => gfDateFunction(d.x, 'MMM DD'),
      y: (d) => parseInt(d.y, 10),
      yAxis: {
        tickFormat: (d) => d3.format(',.0f')(d),
        axisLabelDistance: 1,
      },
    },
  };

  getCommitChartOptions(chartData: any) {
    // Get the min and max values for the Y-axis
    // based on the current data set
    // Lowest is 5, otherwise max + 1
    const min = 0;
    const max =
      _.max(
        [4].concat(_.map(chartData, (series) => {
          return _.map(series.values, 'y');
        }).flat())
      ) + 1;

    const ret: any = _.cloneDeep(this.commitChartOptions);
    ret.chart.forceY = [min, max];
    return ret;
  }

  getCommitChartData(scmData: any) {
    const ret = _.get(scmData, 'rel.chart_data', [])
      .filter((candidate_series) => {
        return _.get(candidate_series, 'label', '') !== '';
      })
      .map((vals) => {
        return {
          key: vals.label === 'None' ? 'Nobody' : vals.label, // e.g., adriandelatabla, tbibbs
          // For each value in the chart_data element,
          // create a data point in the series
          values: vals.values
            .map((item) => {
              // e.g., 2014-08-14: 4 commits
              const dt = new Date(item.statDate + 'T00:00:00');
              const ticks = dt.getTime() + dt.getTimezoneOffset() * 60000;
              return {
                x: new Date(ticks),
                y: item.measure,
              };
            })
            .sort((a, b) => {
              if (a.x > b.x) return 1;
              if (a.x < b.x) return -1;
              return 0;
            }),
        };
      });
    return ret;
  }
}
